// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-edsu1d-MuiButtonGroup-root .MuiButtonGroup-grouped {
    width: 33%;
}

.css-edsu1d-MuiButtonGroup-root {
    margin-right: auto;
    margin-left: auto;
    width: 100%;
    white-space: nowrap;
}
.setting-header {
    display: flex;
    /* width: 100%; */
    padding: 0 0 0 10px;
    justify-content: space-between;
}

.MuiFormControl-root .css-2n9k1h-MuiFormControl-root {
    margin-right: auto !important;
    margin-left: auto !important;
}

.css-2n9k1h-MuiFormControl-root {
    margin-right: auto !important;
    margin-left: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SettingPage.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC","sourcesContent":[".css-edsu1d-MuiButtonGroup-root .MuiButtonGroup-grouped {\r\n    width: 33%;\r\n}\r\n\r\n.css-edsu1d-MuiButtonGroup-root {\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    width: 100%;\r\n    white-space: nowrap;\r\n}\r\n.setting-header {\r\n    display: flex;\r\n    /* width: 100%; */\r\n    padding: 0 0 0 10px;\r\n    justify-content: space-between;\r\n}\r\n\r\n.MuiFormControl-root .css-2n9k1h-MuiFormControl-root {\r\n    margin-right: auto !important;\r\n    margin-left: auto !important;\r\n}\r\n\r\n.css-2n9k1h-MuiFormControl-root {\r\n    margin-right: auto !important;\r\n    margin-left: auto !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
